export default __webpack_public_path__ + "static/media/bannerraridadesmobile.73d0e0dd.png";